import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { IVolunteerActivity } from './models';
import { invalidateVolunteerActivities } from './useVolunteerActivities';

export const useCreateVolunteerActivityMutation = ({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (data: IVolunteerActivity) => void;
} = {}) => {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: ({
			activity,
			impersonationContext,
		}: {
			activity: Partial<IVolunteerActivity>;
			impersonationContext?: Api.IImpersonationContext;
		}) =>
			userSession.webServiceHelper.callAsync<IVolunteerActivity>(
				Api.ImpersonationBroker.composeApiUrl({ impersonationContext, urlPath: 'volunteering/activities' }),
				'POST',
				activity
			),
		onSuccess: data => {
			invalidateVolunteerActivities();
			onSuccess?.(data);
		},
		onError,
	});
};
